const ROUTE_PARAM_CHAPTER_ID = 'chapterId';
const ROUTE_PARAM_TOPIC_ID = 'topicId';

export const ROUTE_PATHS = {
    ROUTE_PARAM_CHAPTER_ID: ROUTE_PARAM_CHAPTER_ID,
    ROUTE_PARAM_TOPIC_ID: ROUTE_PARAM_TOPIC_ID,
};
